import { render, staticRenderFns } from "./ActionTypeSection.vue?vue&type=template&id=dbadab54"
import script from "./ActionTypeSection.vue?vue&type=script&lang=js"
export * from "./ActionTypeSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports